export const VENAQQI_LOGO_URL = "/logo512.png";
export const DON_D_LOGO_URL = "https://res.cloudinary.com/dgdtlohqw/image/upload/e_make_transparent:10/v1778311281/LOGO_OPCION_1_PNG3_lkvrqb.png";
